import React from 'react';
import './ButtonLabel.scss';
function ButtonLabel(_a) {
    var children = _a.children, id = _a.id;
    return (React.createElement("span", { className: "elmo-btn__label", "data-testid": "elmo-btn-label-".concat(id || 'default') }, children));
}
export default ButtonLabel;
